// TODOFILTER: do we really should receive name: '', from BE?
const getName = (name: string): string => name !== '' ? name : 'Other'

export default getName
